module.exports = __webpack_public_path__ + "img/throwDropText1.e04a14d8.png";